import { type FC, type ReactNode } from "react";

import { Skeleton } from "@snapchat/snap-design-system";
import { ExternalLinkIcon } from "@snapchat/snap-design-system-icons";

import { type TosMetadata } from "../../../../gql-generated/types";
import { Flexbox } from "../../Flexbox.styles";
import { TosModalEffectiveDate } from "../messages.generated";

import styles from "./TosModalHeader.module.css";

interface TosModalHeaderProps {
    iconSrc: string;
    headerText: ReactNode;
    sourceUrl?: string;
    effectiveDate?: string;
    tosMetadata?: TosMetadata;
}

export const TosModalHeader: FC<TosModalHeaderProps> = ({
    iconSrc,
    headerText,
    sourceUrl,
    effectiveDate,
    tosMetadata,
}) => {
    return (
        <Flexbox alignItems="center">
            <img className={styles.modalIcon} src={iconSrc} alt="Snapchat ghost logo" />
            <Flexbox flexDirection="column">
                <a className={styles.modalHeader} href={sourceUrl ?? undefined} target="_blank" rel="noreferrer">
                    {headerText}
                    <ExternalLinkIcon size={12} />
                </a>
                <div className={styles.modalSubheader}>
                    {tosMetadata ? (
                        <TosModalEffectiveDate effectiveDate={new Date(effectiveDate ?? Date.now())} />
                    ) : (
                        <Skeleton height={24} />
                    )}
                </div>
            </Flexbox>
        </Flexbox>
    );
};
